import type { PointsOperation } from './types';

export const mockOperations: PointsOperation[] = [
  {
    id: '1',
    transactionNo: 'TXN202501150001',
    operationType: 'recharge',
    transactionTime: '2025-01-15 10:30:25',
    tenantName: '阳光小学',
    transactionAmount: 10000,
    operator: '张三',
    effectiveTime: '2025-01-15 00:00:00',
    expiryTime: '2025-07-15 23:59:59',
    usagePeriod: 180,
    originalTransactionNo: '-',
    deductedPoints: 2500,
    availablePoints: 6500,
    remainingPoints: 7500,
    preConsumedPoints: 1000
  },
  {
    id: '2',
    transactionNo: 'TXN202501140002',
    operationType: 'reversal',
    transactionTime: '2025-01-14 15:20:10',
    tenantName: '明德中学',
    transactionAmount: -5000,
    operator: '李四',
    effectiveTime: '2025-01-10 00:00:00',
    expiryTime: '2025-06-10 23:59:59',
    usagePeriod: 150,
    originalTransactionNo: 'TXN202501100005',
    deductedPoints: 1200,
    availablePoints: 2800,
    remainingPoints: 3800,
    preConsumedPoints: 1000
  },
  {
    id: '3',
    transactionNo: 'TXN202501130003',
    operationType: 'recharge',
    transactionTime: '2025-01-13 09:15:30',
    tenantName: '华夏大学',
    transactionAmount: 50000,
    operator: '王五',
    effectiveTime: '2025-01-13 00:00:00',
    expiryTime: '2026-01-13 23:59:59',
    usagePeriod: 365,
    originalTransactionNo: '-',
    deductedPoints: 15000,
    availablePoints: 32000,
    remainingPoints: 35000,
    preConsumedPoints: 3000
  },
  {
    id: '4',
    transactionNo: 'TXN202501120004',
    operationType: 'recharge',
    transactionTime: '2025-01-12 14:45:20',
    tenantName: '启明小学',
    transactionAmount: 8000,
    operator: '赵六',
    effectiveTime: '2025-01-12 00:00:00',
    expiryTime: '2025-04-12 23:59:59',
    usagePeriod: 90,
    originalTransactionNo: '-',
    deductedPoints: 3200,
    availablePoints: 4300,
    remainingPoints: 4800,
    preConsumedPoints: 500
  },
  {
    id: '5',
    transactionNo: 'TXN202501110005',
    operationType: 'reversal',
    transactionTime: '2025-01-11 11:30:15',
    tenantName: '博文中学',
    transactionAmount: -3000,
    operator: '孙七',
    effectiveTime: '2025-01-05 00:00:00',
    expiryTime: '2025-07-05 23:59:59',
    usagePeriod: 180,
    originalTransactionNo: 'TXN202501050008',
    deductedPoints: 800,
    availablePoints: 1700,
    remainingPoints: 2200,
    preConsumedPoints: 500
  },
  {
    id: '6',
    transactionNo: 'TXN202501100006',
    operationType: 'recharge',
    transactionTime: '2025-01-10 16:20:40',
    tenantName: '育才高中',
    transactionAmount: 20000,
    operator: '周八',
    effectiveTime: '2025-01-10 00:00:00',
    expiryTime: '2025-10-10 23:59:59',
    usagePeriod: 270,
    originalTransactionNo: '-',
    deductedPoints: 8000,
    availablePoints: 10500,
    remainingPoints: 12000,
    preConsumedPoints: 1500
  },
  {
    id: '7',
    transactionNo: 'TXN202501090007',
    operationType: 'recharge',
    transactionTime: '2025-01-09 10:10:25',
    tenantName: '实验小学',
    transactionAmount: 15000,
    operator: '吴九',
    effectiveTime: '2025-01-09 00:00:00',
    expiryTime: '2025-07-09 23:59:59',
    usagePeriod: 180,
    originalTransactionNo: '-',
    deductedPoints: 5000,
    availablePoints: 8500,
    remainingPoints: 10000,
    preConsumedPoints: 1500
  },
  {
    id: '8',
    transactionNo: 'TXN202501080008',
    operationType: 'reversal',
    transactionTime: '2025-01-08 13:50:30',
    tenantName: '文华中学',
    transactionAmount: -2000,
    operator: '郑十',
    effectiveTime: '2025-01-01 00:00:00',
    expiryTime: '2025-06-01 23:59:59',
    usagePeriod: 150,
    originalTransactionNo: 'TXN202501010010',
    deductedPoints: 600,
    availablePoints: 1200,
    remainingPoints: 1400,
    preConsumedPoints: 200
  }
];
